import { useEffect, useState } from "react";
import { IProducts } from "../../interfaces/shopify";
import { getFeatureProduct } from "../../services/getProductFeatured";
import { Box, Fade, Link, Typography, useTheme } from "@mui/material";
import { LoadText } from "../LoadText/LoadText";
import { ArrowSplideRight } from "../../icons";
import { EmblaFeatured } from "../EmblaFeatured/EmblaFeatured";
import { To } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";

type CarruselFeaturedProps = {
  to: To;
  category: string;
  customTitle?: string;
  sortKey: string;
};
export const CarruselFeatured = ({
  to,
  category,
  customTitle,
  sortKey,
}: CarruselFeaturedProps) => {
  const [featured, setFeatured] = useState<IProducts[]>([]);
  const [categoryTitle, setCategoryTitle] = useState<string>();
  const [loading, setLoading] = useState(true);
  const theme = useTheme();

  useEffect(() => {
    const getData = async () => {
      try {
        const data = await getFeatureProduct(category, sortKey);
        setFeatured(data.products);
        setCategoryTitle(data.categoryTitle);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [category, sortKey]);

  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        marginTop={8}
        paddingBlock={1}
      >
        {customTitle ? (
          <Box>
            <Typography
              sx={{
                fontSize: { xs: 15, md: 25 },
                textTransform: "uppercase",
                color: theme.palette.secondary[800],
                fontWeight: 800,
              }}
            >
              {customTitle}
            </Typography>
          </Box>
        ) : (
          <Box
            display="flex"
            sx={{
              background: `linear-gradient(50deg, ${theme.palette.secondary[900]} , ${theme.palette.secondary[300]} 70%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            alignItems="center"
            gap={2}
            marginInline={5}
          >
            <Typography
              sx={{
                fontSize: { xs: 15, md: 25 },
                textTransform: "uppercase",
                color: theme.palette.secondary[800],
                fontWeight: 800,
              }}
            >
              Featured
            </Typography>
            {loading ? (
              <LoadText />
            ) : (
              <Fade in timeout={1000}>
                <Typography
                  sx={{
                    fontSize: { xs: 15, md: 25 },
                    textTransform: "uppercase",
                    color: theme.palette.secondary[800],
                    fontWeight: 800,
                  }}
                >
                  {categoryTitle?.split("-")}
                </Typography>
              </Fade>
            )}
          </Box>
        )}

        <Box display="flex" alignItems="center" marginInline={4} gap={1}>
          <Link
            component={RouterLink}
            to={to}
            sx={{
              fontSize: { xs: 12, md: 15 },
              fontWeight: 500,
              zIndex:999,
              color: theme.palette.primary[600],
              textDecoration: "none",
            }}
          >
            View All
          </Link>
          <ArrowSplideRight
            sx={{ width: 12, height: 12 }}
            htmlColor={theme.palette.primary[600]}
          />
        </Box>
      </Box>
      <EmblaFeatured
        isLoading={loading}
        category={categoryTitle}
        slides={featured}
        options={{
          dragFree: true,
        }}
      />
    </Box>
  );
};
